<script lang="ts">
  import SimilarCompany from "$lib/components/blog/similar-company.svelte";
  import GridSkeleton from "$lib/components/ui/skeleton/grid-skeleton.svelte";
  import type { PageData } from "./$types";
  // import Newsletter from "$lib/components/blog/newsletter.svelte";

  export let data: PageData;
</script>

<div class="columns-1 gap-7 pt-8 lg:mb-16 lg:columns-2 lg:pt-14">
  <p class="mb-10 text-blog-gray-900 dark:text-blog-gray-300 lg:mb-0">{data.description}</p>

  {#each data.profiles as profile}
    <div>
      <h3 class="mb-2 mt-6 font-bold">{profile.title}</h3>
      <p class="mb-10 text-blog-gray-900 dark:text-blog-gray-300 lg:mb-0">{profile.content}</p>
    </div>
  {/each}
</div>

<h1 class="text-[1.375rem] font-bold tracking-tighter">Companies similar to {data.name}</h1>

<div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
  {#await data.similarCompanies}
    <GridSkeleton count={2} css="my-6" />
  {:then similarCompanies}
    {#each similarCompanies as company}
      <SimilarCompany
        companyName={company.name}
        companyUrl={company.domain}
        description={company.description}
        logoUrl={company.smallLogoThumbUrl}
      />
    {/each}
  {/await}
</div>
